export default __webpack_public_path__ + "static/media/Real-Time Bluedot Wayfinding.eee79845.svg";